export interface GapiBaseData {
  id: string,
  kind: string,
  mimeType: string,
  name: string
}

abstract class Node {
  constructor(public data: GapiBaseData, public root = false, public loaded = false) {}

  load = () => this.loaded = true
  setRoot = (isRoot: boolean) => this.root = isRoot
}

// Composite
export class Folder extends Node {
  childs: (Document|Folder)[];
  isOpen = false;
  parent = null;

  constructor(data: GapiBaseData) {
    super(data);
  }

  addChilds(childs: (Document|Folder)[]): void {
    this.childs = childs;
  }

  getChilds(): (Document|Folder)[] {
    return this.childs;
  }

  getFolders() {
    return this.childs?.filter(node => node instanceof Folder)
  }

  toggleOpen = () => this.isOpen = !this.isOpen;
}

// Leaf
export class Document extends Node {
  constructor(data: GapiBaseData) {
    super(data);
  }
}
